import * as React from 'react';
import { UitkSpacing } from 'uitk-react-spacing';
import { buildClassnames } from './header-region';
export var BaseHeader = function (props) {
    var className = props.className, children = props.children;
    var classes = buildClassnames('site-header', className);
    return (React.createElement(UitkSpacing, { padding: { block: 'four' } },
        React.createElement("header", { className: classes }, children),
        ";"));
};
//# sourceMappingURL=base-header.js.map